import {Injectable} from '@angular/core';
import {TenantService} from '../../services/tenant.service';
import {from, Observable} from 'rxjs';
import {TeamMember} from '../../models/team-member.model';
import {concatMap, filter, first, map} from 'rxjs/operators';
import {increment} from '@firebase/firestore';
import {readCollectionWithIds} from '../../common/firestore-utils';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {LoadingService} from '../../shared/services/loading.service';
import { addDoc, collection, collectionData, deleteDoc, doc, docData, Firestore, updateDoc } from '@angular/fire/firestore';
import { Auth, authState, idToken } from '@angular/fire/auth';


@Injectable({
  providedIn:'root'
})
export class EditTeamService {


  constructor(
    private tenant: TenantService,
    private afAuth: Auth,
    private loading: LoadingService,
    private firestore: Firestore,
    private http: HttpClient) {

  }

  loadTeamSize(): Observable<number> {
    return authState(this.afAuth)
      .pipe(
        filter(user => !!user),
        first(),
        concatMap(user => docData(doc(this.firestore, `/schools/${this.tenant.id}/usersPrivate/${user.uid}`), {idField: "id"})),
        map((user:any) => user.maxTeamSize),
        first()
      )
  }

  loadTeamMembers(): Observable<TeamMember[]> {    
    return authState(this.afAuth)
      .pipe(
        filter(user => !!user),
        first(),
        concatMap(user => readCollectionWithIds<TeamMember[]>(collectionData(collection(this.firestore,`schools/${this.tenant.id}/usersPrivate/${user.uid}/teamMembers`), {idField: "id"}))),
        first()
      )
  }

  addTeamMember(teamMember: Partial<TeamMember>): Observable<any> {

    const saveTeamMember$ = authState(this.afAuth)
      .pipe(
        filter(user => !!user),
        first(),
        concatMap(user => from(
           addDoc(collection(this.firestore, `schools/${this.tenant.id}/usersPrivate/${user.uid}/teamMembers`), teamMember)
        )),
        first(),
        map(ref => {
          return {
            id:ref.id,
            ...teamMember
          }
        })
      );

    return this.loading.showLoaderUntilCompleted(saveTeamMember$);
  }

  resendLink(teamMember: TeamMember) {
    const resendLink$ = authState(this.afAuth)
      .pipe(
        filter(user => !!user),
        first(),
        concatMap(user => from(
          updateDoc(doc(this.firestore, `schools/${this.tenant.id}/usersPrivate/${user.uid}/teamMembers/${teamMember.id}`), {linksSentCounter: increment(1)})
        )),
        first()
      );

    return this.loading.showLoaderUntilCompleted(resendLink$);
  }

  removeTeamMember(teamMember: TeamMember) :Observable<any> {

    const removeTeamMember$ = authState(this.afAuth)
      .pipe(
        filter(user => !!user),
        concatMap(user => from(
          deleteDoc(doc(this.firestore, `schools/${this.tenant.id}/usersPrivate/${user.uid}/teamMembers/${teamMember.id}`))
        )),
        first()
      );

    return this.loading.showLoaderUntilCompleted(removeTeamMember$);

  }

  activateTeamMember(managerUserId:string, teamMemberId:string): Observable<any> {
    return idToken(this.afAuth)
      .pipe(
        filter(jwt => !!jwt),
        first(),
        concatMap(() => this.http.post<any>(environment.api.activateTeamMemberUrl, {
          managerUserId,
          teamMemberId,
          tenantId: this.tenant.id
        })),
      );
  }

  updateTeamSize(newTeamSize:number) :Observable<any> {
    return this.http.post(environment.api.updateTeamSizeUrl, {newTeamSize});
  }


}
